var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "url(#paint0_linear_544_34430)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_34430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 13.5938H28.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 17.8125H28.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 25.4062H12.0625V12.75C12.0625 12.0787 12.3292 11.4348 12.8039 10.9601C13.2786 10.4854 13.9224 10.2188 14.5938 10.2188H26.4062C27.0776 10.2188 27.7214 10.4854 28.1961 10.9601C28.6708 11.4348 28.9375 12.0787 28.9375 12.75V25.4062Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 25.4062V27.9375C28.9375 28.1613 28.8486 28.3759 28.6904 28.5341C28.5321 28.6924 28.3175 28.7812 28.0938 28.7812H25.5625C25.3387 28.7812 25.1241 28.6924 24.9659 28.5341C24.8076 28.3759 24.7188 28.1613 24.7188 27.9375V25.4062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2812 25.4062V27.9375C16.2812 28.1613 16.1924 28.3759 16.0341 28.5341C15.8759 28.6924 15.6613 28.7812 15.4375 28.7812H12.9062C12.6825 28.7812 12.4679 28.6924 12.3096 28.5341C12.1514 28.3759 12.0625 28.1613 12.0625 27.9375V25.4062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7031 22.6641C17.2856 22.6641 17.7578 22.1919 17.7578 21.6094C17.7578 21.0269 17.2856 20.5547 16.7031 20.5547C16.1206 20.5547 15.6484 21.0269 15.6484 21.6094C15.6484 22.1919 16.1206 22.6641 16.7031 22.6641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2969 22.6641C24.8794 22.6641 25.3516 22.1919 25.3516 21.6094C25.3516 21.0269 24.8794 20.5547 24.2969 20.5547C23.7144 20.5547 23.2422 21.0269 23.2422 21.6094C23.2422 22.1919 23.7144 22.6641 24.2969 22.6641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3125 14.4375V16.9688",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 14.4375V16.9688",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_544_34430",
    x1: -8.11245,
    y1: 31.9626,
    x2: 50.7716,
    y2: 1.40153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_34430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBus);
export default __webpack_public_path__ + "static/media/icon_bus.6d7f58631f9dd6350754a7c67042063a.svg";
export { ForwardRef as ReactComponent };